export type DataForwarderRetryStatus = "error" | "retried";

export interface DataForwarderRetryRow {
  transId: string;
  dwAccountId: string;
  orgName: string;
  targetDate: string; // YYYY-MM-DD
  channel: string;
  reportTypesJson: string; // Python의 json.dumps(report_type list) 형태 유지
  status: DataForwarderRetryStatus;
  createdAt: string; // "YYYY-MM-DD HH:mm:ss" (표시용)
}

export interface DataForwarderRetryResultSummary {
  successTransIds: string[];
  failedTransIds: string[];
  message: string; // 화면에 보여줄 요약 텍스트
}

export const APPSFLYER_REPORT_TYPES = [
  "all",
  "non-organic_installs",
  "non-organic_in-app-events",
  "retargeting_conversions",
  "retargeting_in-app-events",
  "organic_installs",
  "organic_in-app-events",
] as const;

export type AppsflyerReportType = (typeof APPSFLYER_REPORT_TYPES)[number];

export interface AppsflyerRawDeleteSearchParams {
  dwAccountId: string;
  reportType: AppsflyerReportType;
  startDate?: string; // YYYY-MM-DD
  endDate?: string; // YYYY-MM-DD
}

export interface AppsflyerRawDeleteState {
  params: AppsflyerRawDeleteSearchParams;
  s3KeysToDelete: string[];
  isLoading: boolean;
}